export const CREATE_COMPANY_REQUEST = 'CREATE_COMPANY_REQUEST';
export const CREATE_COMPANY_SUCESS = 'CREATE_COMPANY_SUCESS';
export const CREATE_COMPANY_ERROR = 'CREATE_COMPANY_ERROR';
export const COMPANY_RESET = 'COMPANY_RESET';

export const SEARCH_COMPANY_REQUEST = 'SEARCH_COMPANY_REQUEST';
export const SEARCH_COMPANY_SUCESS = 'SEARCH_COMPANY_SUCESS';
export const SEARCH_COMPANY_ERROR = 'SEARCH_COMPANY_ERROR';

export const SEARCH_SPECIFY_COMPANY_REQUEST = 'SEARCH_SPECIFY_COMPANY_REQUEST';
export const SEARCH_SPECIFY_COMPANY_SUCESS = 'SEARCH_SPECIFY_COMPANY_SUCESS';
export const SEARCH_SPECIFY_COMPANY_ERROR = 'SEARCH_SPECIFY_COMPANY_ERROR';

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_SUCESS = 'UPDATE_COMPANY_SUCESS';
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR';
export const UPDATE_COMPANY_RESET = 'UPDATE_COMPANY_RESET';
